<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m13.8 17.583.007-16.536h3.03a5.751 5.751 0 0 0 2.526 3.764l.002.001c.903.587 1.98.93 3.135.93v4.124a9.868 9.868 0 0 1-5.76-1.846v8.386c0 4.187-3.418 7.594-7.62 7.594-1.624 0-3.13-.51-4.367-1.376l-.002-.003A7.582 7.582 0 0 1 1.5 16.405c0-4.188 3.418-7.595 7.62-7.595.349 0 .69.029 1.027.074v.978c-3.833.089-6.976 3.011-7.393 6.743.417-3.731 3.56-6.653 7.393-6.742v3.234a3.44 3.44 0 0 0-1.027-.16 3.478 3.478 0 0 0-3.48 3.469c0 1.331.758 2.488 1.866 3.07a3.476 3.476 0 0 0 5.088-2.94L12.6 0h4.14c0 .358.035.707.098 1.047h-3.031L13.8 17.583z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
